<template>
    <v-container class="step-container" v-if="unit && current">
        <c-drop-message
            v-if     = "drag.notAllowed"
            :message ="drag.message"
        />

        <drop class="cut" @drop="onDrop" mode="cut" :accepts-type="onAcceptType">
            <v-row class="no-frame">
                <v-col class="step-first-column">
                    <inc-status
                        v-model = "current.status"
                        :items  = "step.status"
                        @change = "onStatusChanged"
                        :background = "fileEntryFieldBackground"
                        class   = "mt-6"
                    />

                    <v-row class="no-frame">
                        <v-col class="no-frame col-12">
                            <msd-users
                                v-model     = "incident.responsible"
                                :background = "fileEntryFieldBackground"
                            />
                        </v-col>
                    </v-row>


                    <c-v-spacer />
                </v-col>
                <v-col class="step-middle-column pa-0" style="border: none">
                    <!-- Abstract of maintenance contract data -->
                    <c-contract-mnt-abstract
                        v-if      = "data.tags.includes('contract')"
                        class      = "lm-border mt-0 mb-3"
                        :show-unit = "this.data.collection.length > 1"
                        style      = "height: 200px;"
                    />
                    <!-- Abstract of maintenance contract data -->

                    <div class="lm-border pa-3" :style="data.tags.includes('contract') ? 'min-height: 478px' : 'min-height: 690px'">
                        <v-row class="no-frame">
                            <v-col class="no-frame col-6 pr-2">
                                <f-date-picker
                                    label   = "inc.maintenance.exedate"
                                    v-model = "data.executiondate"
                                    :background-color = "fileEntryFieldBackground"
                                    :rules  = "[requiredRule]"
                                    class   = "w-100"
                                    @change = "onExecutiondate"
                                />
                            </v-col>
                        </v-row>

                        <v-row class="no-frame mt-2" >
                            <inc-manufacturer
                                v-model     = "data.manufacturer"
                                :rules      = "[requiredComboRule]"
                                :background = "fileEntryFieldBackground"
                                @changed    = "onManufacturer"
                            />
                        </v-row>

                        <v-row class="no-frame">
                            <v-col class="no-frame col-12">
                                <v-text-field
                                    label="Servicetechniker"
                                    v-model="data.technician"
                                    :readonly      = "readonly"
                                    :disabled      = "readonly"
                                    :background-color="fileEntryFieldBackground"
                                    autocomplete   = "off"
                                    autocorrect    = "off"
                                    autocapitalize = "off"
                                    spellcheck     = "false"
                                />
                            </v-col>
                        </v-row>


                        <v-row class="no-frame">
                            <v-col class="no-frame col-6 pr-2">
                                <v-text-field
                                    label          = "Vertragsnummer"
                                    v-model        = "data.contractNo"
                                    :readonly      = "readonly"
                                    :disabled      = "readonly"
                                    :background-color="fileEntryFieldBackground"
                                    autocomplete   = "off"
                                    autocorrect    = "off"
                                    autocapitalize = "off"
                                    spellcheck     = "false"
                                />
                            </v-col>
                            <v-col class="no-frame col-6 pl-2">
                                <v-text-field
                                    label             = "Auftragsnummer"
                                    v-model           = "data.orderNo"
                                    :readonly         = "readonly"
                                    :disabled         = "readonly"
                                    :background-color = "fileEntryFieldBackground"
                                    autocomplete      = "off"
                                    autocorrect       = "off"
                                    autocapitalize    = "off"
                                    spellcheck        = "false"
                                />
                            </v-col>
                        </v-row>
                    </div>
                    <c-v-spacer />
                </v-col>
                <v-col class="step-middle-column">
                    <v-textarea
                        v-model        = "current.description"
                        :label         = "$t('inc.edit.general.description')"
                        :rows          = "rows"
                        class          = "mt-4"
                        autocomplete   = "off"
                        autocorrect    = "off"
                        autocapitalize = "off"
                        spellcheck     = "false"
                        no-resize
                        counter
                    />
                    <v-textarea
                        v-model        = "current.result"
                        label         = "Ergebnis"
                        :rows          = "rows"
                        class          = "mt-3"
                        autocomplete   = "off"
                        autocorrect    = "off"
                        autocapitalize = "off"
                        spellcheck     = "false"
                        no-resize
                        counter
                    />
                    <c-v-spacer />
                </v-col>
                <v-col class="step-last-column" style="padding-right: 5px">
                    <crm-journal
                        :incident = "incident"
                        @front    ="onJournalFront"
                        style     = "margin-top: -10px"
                    />
                </v-col>
            </v-row>
        </drop>
    </v-container>
</template>

<script>

import {Drop} from "vue-easy-dnd"

import Core from "@/modules/core/service/Core";
import Inb from "@/modules/inb/service/Inb";
import Inc from "@/modules/inc/service/Inc.js";
import FDatePicker from "@/modules/core/components/utils/FDatePicker.vue";
import IncStatus from "@/modules/inc/steps/components/common/IncStatus.vue";
import MsdUsers from "@/modules/msd/user/components/controls/MsdUsers.vue";
import IncManufacturer from "@/modules/inc/steps/components/common/IncManufacturer.vue";
import CrmJournal from "@/modules/crm/components/main/CrmJournal.vue";
import CVSpacer from "@/modules/core/components/utils/CVSpacer.vue";
import Mail from "@/modules/inc/mail/service/Mail";
import StepMixin from "@/modules/inc/steps/components/mixins/StepMixin";
import CDropMessage from "@/modules/inc/steps/components/common/CDropMessage.vue";
import CContractMntAbstract from "@/modules/msd/company/contract/components/controls/mnt/CContractMntAbstract.vue";

export default {
    name: "IncMaintenance",

    mixins: [
        StepMixin
    ],

    components: {
        CContractMntAbstract,
        CDropMessage,
        CVSpacer,
        IncManufacturer,
        MsdUsers,
        IncStatus,
        FDatePicker,
        CrmJournal,
        Drop
    },

    props: {
        incident: {
            required: true,
            type: Object,
            default: function () {
                return {
                    responsible: null,
                    beginDate  : null,
                    endDate    : null
                }
            }
        },

        data: {
            required: true,
            type: Object,
            default: function () {
                return {
                    executionDate: null,
                    reporter     : null,
                    contactIds   : [],
                    current      : null,
                    data         : [
                        {
                            clipboardEntry : null
                        }
                    ]
                }
            }
        },

        changes: {
            type: Function,
        },

        step: {
            required: true,
            type: Object,
        },

        index: {
            required: true,
            type    : Number
        },
    },

    data: () => ({
        drag: {
            notAllowed: false,
            message   : null
        },

        refresh: 0,
        details: false,
        valid  : false,
        rows   : 13,
        selectWarranty: null,
        selectedContacts: null,
    }),


    created() {
        this.freeze = JSON.stringify(this.data);
        this.$bus.$on(this.$events.drag.end, this.onDragend);
    },

    beforeDestroy() {
        this.$bus.$off(this.$events.drag.end, this.onDragend);
    },

    mounted() {
        this.form = this.$parent;
        this.$nextTick(() => {
            this.form.validate();
            this.initBase();
        });
    },

    computed: {
        fileEntryFieldBackground () {
            return Inc.style.fileEntryFieldBackground(this.data);
        }
   },

    methods: {
        _validate() {
            if (!this.unit) {
                return;
            }

            this.current.valid = this.form.validate();
            let valid = true;
            this.data.collection.forEach(data => {
                if (!data.valid) {
                    valid = false;
                }
            })

            this.valid = valid;
        },

        /**
         * Sets the given unit als new context for the processing step. The visibility of other processing steps and
         * will be adopted to the given unit.
         *
         * @param unit the new unit context.
         */
        _setContext(unit) {
            this.unit = unit;
        },

        /**
         * Checks if the current processing step in the current context is terminated.
         * @returns true, if the processing step is terminated, false otherwise.
         */
        _isTerminated() {
            return this.current.status.type === 'T';
        },

        _status () {
            if (!this.current) {
                return null;
            }

            return this.current.status;
        },

        /**
         * Force an update of relevat componets. E.g. when the list of assigned sites changes.
         */
        _forceUpdate() {
            this.freeze = JSON.stringify(this.data);
            this.refresh++;
        },

        _unitStepStatus(unit) {
            const current = this.data.collection.find(s => s.unit.id === unit.id);
            if (!current) {
                return null;
            }

            return current.valid ? "success" : "error";
        },

        /**
         * Validate the processing step and informs the main dialog about a possible change.
         */
        validate() {
            return this.$nextTick().then(() => {
                this._validate();
                return Promise.resolve();
            })
        },

        /**
         * Checks whether a message can be attached to the current processing step.
         * @param dragData the message
         * @return true, if the message can be attached to the step.
         */
        onAcceptType(dragData) {
            if (!(dragData instanceof Object) || dragData.type === "dms-document") {
                return;
            }

            const accept = Inc.clipboard.accept(dragData, this.incident, [{
                message: "MAINTENANCE",
                incident: null
            }, {
                message : "ORDER",
                incident: null
            }, {
                message : "DEFAULT",
                incident: null
            }, {
                message: "ORDER",
                incident: null
            }, {
                message: "WORKREPORT",
                incident: null
            }, {
                message: "IMAGE",
                incident: null
            },{
                message: "CORRESPONDENCE",
                incident: null
            },
            ], true, true);

            this.drag.notAllowed = !accept.valid;
            this.drag.message    = this.$t(accept.message);

            return accept.valid;
        },

        /**
         * Attaches a message to the processing step.
         * @param event the drag'n drop element that contains the message,
         */
        onDrop(event) {
            console.log("drop", event)
            switch (event.data.type) {
                case 'clipboard':
                    Inc.clipboard.paste (this, event.data.data.id, event.data.data.unit, this.incident.id, this.changes());
                    break;
                case 'inbox':
                    Inb.attach(this, event.data.data.id, this.incident.id, this.step, null, true, (message) => {
                        this.$emit("refresh", message);
                    });
            }
        },

        onDragend () {
            this.drag.notAllowed = false;
        },

        onManufacturer() {
            this.data.contactIds = [];
        },

        onExecutiondate () {
            this.$emit("save", () => {
                console.log("saved")
                this.$bus.$emit(this.$incident.events.refresh.maintenence);
            });
        },

        getMail() {
            return Mail.initialize(this.incident.sites, this.index, this.data, this.current, this.incident, this.step);
        },

        onSendmail(mail) {
            mail.step = this.step.id;
            this.$emit("sendmail", mail);
        },

        requiredRule(value) {
            return Core.rule.required(value);
        },

        requiredComboRule(value) {
            return Core.rule.requiredInCombo(value);
        },

    }
}
</script>

<style scoped>

.contract-empty {
    width: 100%;
    min-height: 200px;
}

</style>
